import api from '@/lib/api';

export type PlatformNotificationSeverity = 'info' | 'warning' | 'danger';

export type PlatformNotification = {
  notification_id: number;
  shop_id: number;
  severity: PlatformNotificationSeverity;
  title: string;
  message: string;
  maintenance_start_at: string;
  maintenance_end_at: string;
  lead_days: number;
  display_start_at: string;
  display_end_at: string;
  is_dismissible: boolean;
};

export const platformNotificationsService = {
  async active() {
    const response = await api.get('/platform-notifications/active');
    return response.data as { success: boolean; data: PlatformNotification[] };
  },
};

